import * as React from "react";
import partnerFitLogo from "../assets/partner-fit.svg";
import fitnessLandingIconAsSVG from "../assets/fitnesstrainer-partnercover.svg";
import partnerFitWhiteLogo from "../assets/partner-fit-white.svg";
import dropout from "../assets/dropout.png";
import twitterLogo from "../assets/twitter.svg";
import instagramLogo from "../assets/instagram.svg";
import facebookLogo from "../assets/facebook.svg";
import youtubeLogo from "../assets/youtube.svg";
import timeIcon from "../assets/time-icon.svg";
import uploadAvatarIcon from "../assets/upload-avatar.svg";
import uploadicon from "../assets/upload-icon.svg";
import nutritionistLogo from "../assets/nutritionist-cover.png";
import nutritionistLandingLogo from "../assets/nutritonists-landing-icon.svg";
import nutritionistMobileLogo from "../assets/nutritionist-mobile-cover.png";
import fitnessTrainerLogo from "../assets/fitnesstrainer-cover.png";
import fitnessTrainerMobileLogo from "../assets/fitnesstrainer-mobile-cover.png";
import yogaTrainerLogo from "../assets/yogaTrainer-cover.png";
import yogaTrainerLandingLogo from "../assets/yoga-landing-icon.svg";
import yogaTrainerMobileLogo from "../assets/yogaTrainer-mobile-cover.png";
import therapistLogo from "../assets/therapist-cover.png";
import therapistLandingLogo from "../assets/therapitst-landing-icon.svg";
import therapistMobileLogo from "../assets/therapist-mobile-cover.png";
import doctorLogo from "../assets/doctor-cover.png";
import doctorLandingLogo from "../assets/doctor-landing-icon.svg";
import doctorMobileLogo from "../assets/doctor-mobile-cover.png";
import physiotherapyLogo from "../assets/physiotherapy-cover.png";
import physiotherapyMobileLogo from "../assets/physiotherapy-mobile-cover.png";
import physiotherapyLandingLogo from "../assets/physiotherapist-landing-icon.png";
import psychiatristLogo from "../assets/psychiatrist-cover.png";
import psychiatristLandingLogo from "../assets/psychiatrists-landing-icon.png";
import psychiatristMobileLogo from "../assets/phychiatrist-mobile-cover.png";
import { Gender, LeadState, Profession, StepType } from "../commons/interfaces";
import affordabilityIcon from "../assets/affordability-icon.svg";
import * as _ from "lodash";

export const NOT_AUTHORIZED_EVENT = "NOT_AUTHORIZED_EVENT";

export const inputFieldOptionalLabel = "(If available)";

export const OTHER = "Other";

export const inputFieldMandatoryLabel = "*";

export const phoneNumberPrefixes = {
  india: "+91",
};

export const defaultUploadHelperText = "pdf / jpg/ jpeg/ png formats, <10MB";

export const partnerEmailAddress = "partner.support@curefit.com";

export const regexValidation = {
  aadharNumber: /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
  panNumber: /([A-Z]|[a-z]){5}([0-9]){4}([A-Z]|[a-z]){1}$/,
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  zipCode: /^[1-9][0-9]{5}$/,
  bankAccountNumber: /^\d{9,18}$/,
  ifscCode: /^[A-Z]{4}0[A-Z0-9]{6}$/,
};

export const loadingScreenValues = {
  onPageloadHeadingText: "Loading your data",
  onPageloadBodyText: "Please wait while we fetch your previous changes",
  onSavingHeadingText: "Saving Your Changes",
  onSavingBodyText: "Please wait while we save your changes",
  onDefaultHeadingText: "Loading",
  ondeafultBodyText: "Please wait...",
  onSaveAndexitWarningHeadingText: "You have unsaved changes",
  onSaveAndExitWarningBodyText:
    "Make sure you save your progress before you go",
  LOAD_QUIZ_MESSAGE: "Please wait while we load quiz",
  SUBMIT_LOAD_MESSAGE: "Please wait while we submit your answers",
  EVALUATION_MESSAGE: "Submit Details for evaluation",
  NO_CHANGES_MESSAGE:
    "No changes can be made to the details once submitted.All the details will be evaluated by our team",
  TEAM_MESSAGE:
    "Our team will now verify these details and notify you on the next steps.",
  ATTENTION_HEADING_MESSAGE: "Attention!!",
  READING_MATERIAL_MESSAGE:
    "Please go through the reading materials provided in this page before attempting the quiz. Quiz can be attempted only once",
  QUIZ_START_WARNING_MESSAGE: "Quiz can be attempted only once",
  ASSETS_LOADING_MESSAGE:
    "Please wait while we upload your content. Also double check your documents before uploading as these will be used for evaluating your profile.",
};

export const ButtonLabel = {
  START_MODULE: "START MODULE",
  CONTINUE: "CONTINUE",
};

export const ToastMessages = {
  WARN_POST_GRADUATION_MESSAGE:
    "You have not uploaded files for the selected 'Post Graduation Certificate'. Please upload/remove the selected to continue",
  WARN_OTHER_GRAD_MESSAGE:
    "You have not uploaded files for the selected 'Other Certificate'. Please upload/remove the selected to continue",
  WARN_QUIZ_SUBMIT:
    "Please fill in all the answers to successfully submit the quiz.",
};

export const routeURL = {
  landingPage: "/",
  partnerPage: (pathParam: string) => `/partner/${pathParam}`,
  feeStructurePage: "/feeStructure",
  faqPage: "/faq",
  registrationPage: "/registration",
  dashboard: "/dashboard",
  partnerFilledForm: (userId: string, userFormId: string) =>
    `/partnerQuiz/${userId}/${userFormId}`,
  partnerNewForm: (userId: string) => `/partnerQuiz/${userId}`,
  customFormTest: `/partnerQuiz`,
  welcomeAboardScreen: "/welcomeAboard",
  finalCongratulationsPage: "/congratulations",
  finalAgreementPage: "/tdsDeclaration",
  notFoundscreen: "/404",
  termsConditionsPage: "/tc",
  selfieVideoPreSignedURLPage: (leadID: string, uploadType: string) =>
    `/common/signed-videos/${leadID}/${uploadType}`,
};

export const buttonActions = {
  SIGNUP: "signup",
  SIGNIN: "signin",
};

export enum countryCodes {
  INDIA = "+91",
}

export enum GAEvents {
  LOGIN = "Login",
  JOIN_US_NOW = "Join Us Now",
  SIGN_IN_OTP = "Sign In OTP",
  RESEND_OTP = "Resend OTP",
  PRIVACY_POLICY = "PRIVACY POLICY",
  CONTACT_US = "CONTACT US",
  FAQ = "FAQ",
  PARTNERS_SPEAK = "PARTNERS SPEAK",
}

export const modalStyles = {
  [buttonActions.SIGNUP]: { width: 720 },
  [buttonActions.SIGNIN]: { width: 420 },
};

export const pageTypes = {
  landingPage: "landingPage",
  partnerCentricPage: "partnerCentricPage",
  registration: "registration",
};

export const allowedFileTypes = {
  jpg: ".jpg",
  jpeg: ".jpeg",
  pdf: ".pdf",
  png: ".png",
  videoFormat:
    ".mp4, .mov, .m4v, .webm, .mpg, .mp2, .mpeg, .mpv, .avi, .wmv, .qt, .flv, .swf",
};

export enum assetExtensionsFromServer {
  jpg = "jpg",
  jpeg = "jpeg",
  pdf = "pdf",
  png = "png",
}

export enum UploadTypes {
  PROFILE_PICTURE = "PROFILE_PICTURE",
  RESUME = "RESUME",
  GRADUATION_CERTIFICATE = "GRADUATION_CERTIFICATE",
  POST_GRADUATION_CERTIFICATE = "POST_GRADUATION_CERTIFICATE",
  SELFIE_VIDEO = "SELFIE_VIDEO",
  AADHAR_CARD = "AADHAR_CARD",
  OTHER_CERTIFICATIONS = "OTHER_CERTIFICATIONS",
  MEDICAL_REGISTRATION_CERTIFICATE = "MEDICAL_REGISTRATION_CERTIFICATE",
  SCANNED_SIGNATURE = "SCANNED_SIGNATURE",
  GST_TEMPLATE = "GST_TEMPLATE",
  CONTRACT_TEMPLATE = "CONTRACT_TEMPLATE",
  GST_DOCUMENT = "GST_DOCUMENT",
  CONTRACT_DOCUMENT = "CONTRACT_DOCUMENT",
  STUDY_MATERIAL = "STUDY_MATERIAL",
}

export const getNameFromStatusString = (statusFromAPI: string) => {
  switch (statusFromAPI) {
    case LeadState.CREATED:
      return "Created";

    case LeadState.BASIC_INFO:
      return "Basic Information";

    case LeadState.LANGUAGE_PROFICIENCY_CHECK:
      return "Language proficiency";

    case LeadState.DIGITAL_COURSES:
      return "Digital Courses";

    case LeadState.FINAL_ASSESSMENT_MODULE:
      return "Final Module";

    case LeadState.PRELIMINARY_QUIZ:
      return "Premiliminary Quiz";

    case LeadState.PROFESSIONAL_INFO:
      return "Professional Details";

    case LeadState.WORKSPACE_DETAILS:
      return "Work Place Details";

    case LeadState.SELFIE_VIDEO:
      return "Selfie Video";

    case LeadState.KYC_UPLOAD:
      return "KYC Details";

    case LeadState.BANK_DETAILS:
      return "Bank Details";

    case LeadState.PROFILE_SETUP:
      return "Public Profile Details";

    default:
      return "";
  }
};

export const fontSizes = {
  // 12px
  xxs: "0.75em",
  // 14px
  xs: "0.875em",
  // 16px
  sm: "1em",
  // 20px
  md: "1.25em",
  // 22px
  lg: "1.375em",
  // 24px
  xlg: "1.5em",
  // 32px
  xxlg: "2em",
  // 40px
  miniLarge: "2.5em",
  // 44px
  large: "2.75em",
  // 50px
  tabletFooter: "3.125em",
  // 100px - For monitor
  extraLargeFooter: "5.25em",
  //85px
  largeFooter: "4.3125em",
};

export enum fontWeight {
  light = 300,
  regular = 400,
  medium = 500,
  bold = 800,
}

export const modalWidthPercentage = "15%";

export const fontTypes = {
  bodyFont: `var(--body-font)`,
  bold: `var(--bold-font)`,
  meduim: `var(--medium-font)`,
  light: `var(--light-font)`,
  black: `var(--black-font)`,
};

export enum PropValuesEnum {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal",
}

export const portalWorkingWaysHeading = "Working with us is easy";
export const portalWorkingWays = [
  {
    icon: "time-background-icon.svg",
    description: "Work from where you are, when you can",
  },
  {
    icon: "running-man-background-icon.svg",
    description: "Connect with millions, digitally",
  },
  {
    icon: "card-background-icon.svg",
    description: "Get paid for all your sessions, regularly and on time",
  },
];
export const joiningSteps = [
  {
    icon: "hand-icon.svg",
    description: "Join us and provide your basic details",
  },
  {
    icon: "tick-mark-icon.svg",
    description: "Complete the whole onboarding process",
  },
  {
    icon: "card-icon.svg",
    description: "Provide payment and bank details",
  },
  {
    icon: "cam-icon.svg",
    description: "Go Live and provide services to the users",
  },
];

export const joiningReasonsHeading = "Why Partner with us?";
export const joiningReasons = [
  {
    icon: "reach-icon.svg",
    heading: "Reach Millions",
    description:
      "Widen your reach to lakhs of customers & grow with the support of Curefit  team",
  },
  {
    icon: "affordability-icon.svg",
    heading: "More Earnings",
    description:
      "Get paid based on the number of sessions you do in a period, more sessions more earnings.",
  },
  {
    icon: "time-icon.svg",
    heading: "Work according to your convenience",
    description: "Provide services from a location & time of your choice",
  },
  {
    icon: "transparent-icon.svg",
    heading: "Transparent opportunities",
    description: "Equal opportunities for all partners to grow",
  },
];

export const cfBlogData = [
  {
    icon: <img src={dropout} alt="" />,
    heading: "Fitness at Cult.fit",
    shortDescription:
      "Know how partners are providing fitness services online via cult.fit",
  },
  {
    icon: <img src={dropout} alt="" />,
    heading: "Fitness at Cult.fit",
    shortDescription:
      "Know how partners are providing fitness services online via cult.fit",
  },
  {
    icon: <img src={dropout} alt="" />,
    heading: "Fitness at Cult.fit",
    shortDescription:
      "Know how partners are providing fitness services online via cult.fit",
  },
  {
    icon: <img src={dropout} alt="" />,
    heading: "Fitness at Cult.fit",
    shortDescription:
      "Know how partners are providing fitness services online via cult.fit",
  },
  {
    icon: <img src={dropout} alt="" />,
    heading: "Fitness at Cult.fit",
    shortDescription:
      "Know how partners are providing fitness services online via cult.fit",
  },
  {
    icon: <img src={dropout} alt="" />,
    heading: "Fitness at Cult.fit",
    shortDescription:
      "Know how partners are providing fitness services online via cult.fit",
  },
  {
    icon: <img src={dropout} alt="" />,
    heading: "Fitness at Cult.fit",
    shortDescription:
      "Know how partners are providing fitness services online via cult.fit",
  },
  {
    icon: <img src={dropout} alt="" />,
    heading: "Fitness at Cult.fit",
    shortDescription:
      "Know how partners are providing fitness services online via cult.fit",
  },
];

export const feeStructureDetails = [
  {
    type: "Non-Medical Services",
    content: [
      {
        imgURL: affordabilityIcon,
        heading: "Pricing and Payment Collection",
        body:
          "You will be paid a fixed half-hourly / hourly session based fee against successful delivery and utilisation of your services. You may be additionally required to conclude relevant formalities and raise invoices to receive such payments. You understand that collection of fee(s) from customers, i.e. end user(s) shall, only be done vide Platform’s online payments facility (including mobile wallets/UPI, etc.).",
      },
      {
        imgURL: timeIcon,
        heading: "Payment Remittance Cycle",
        body:
          "For successful sessions conducted by you between 1 st to 15 th calendar date of any month, payment will be made to you by 22 nd calendar date of the same month. For successful sessions conducted by you between 16 th to respective calendar month end date of that month, payment will be made to you by 7 th calendar date of the next month.",
      },
    ],
  },
  {
    type: "Medical Services",
    content: [
      {
        imgURL: affordabilityIcon,
        heading: "Pricing and Payment Collection",
        body:
          "You will be charged a percentage of your consultation fee as platform and other related services fee, plus applicable taxes, for using the Platform technology and related services. Collection of your consultation fee from patients shall be done by the Platform on your behalf, vide online payments (including mobile wallets/card payments/ net banking /UPI etc.).",
      },
      {
        imgURL: timeIcon,
        heading: "Payment Remittance Cycle",
        body:
          "Your consultation fees collected by the Platform shall be settled with / remitted to you on a weekly basis after deducting / retaining any platform and other related services fee, plus applicable taxes.",
      },
    ],
  },
];

export const genderTypes = [
  { label: Gender.MALE, value: Gender.MALE },
  { label: Gender.FEMALE, value: Gender.FEMALE },
  { label: Gender.OTHER, value: Gender.OTHER },
];

export const booleanRadioValues = [
  { label: "YES", value: "YES" },
  { label: "NO", value: "NO" },
];

export const color = {
  whitishGray: "#f2f4f8",
  blue: "#3888ff",
  greyishWhite: "#fcf7f8",
  blackWithLightOpacity: "#00000063",
  shadedGray: "#d1daec",
  maroonishGray: "#33363f",
  white: "#ffffff",
  lightishGray: "#888e9e",
  lightishGrayShadow: "rgba(136, 142, 158, 0.1)",
  customModalBackShadow: "0 1.25em 2.625em 32em rgba(0,0,0,0.07)",
  partnerPageShade: "rgb(0 0 0 / 0.25)",
  black: "#000000",
  lightBlack: "#0D0E12",
  red: "#FF3278",
  borderGreen: "#6e6e6e",
  lightCement: "#cccccc",
  pinkishGray: "#92b2dd",
  pink: "#FF367A",
  cardShadow: "#f0f0f0",
  gray: "#e2e4e8",
  mediumLightGray: "#999",
  lighterGray: "#33363f",
  backgroundGray: "#d2d2d2",
  darkRed: "#ff3276",
  lightFooter: "#edf1fb",
  darkMaroon: "#222222",
  gold: "#fff8ed",
  lightishBlue: "#333747",
  disbaledShadow: "#d8d8d8",
  yellow: "#ffa300",
  ligitishYellowShadow: "rgba(255, 163, 0, 0.03)",
  green: "#4ab74a",
  lighShadeBlue: "#b3e0ff",
  brownishLightGray: "#d6dfe0",
  ligitishGreenShadow: "rgba(74, 183, 74, 0.06)",
  orange: "#de4040",
  orangishYellow: "#dcfce4",
  ligitishOrangeShadow: "rgba(176, 0, 32, 0.03)",
  shadow: "rgba(0, 0, 0, 0.07)",
  seaShadeBlue: "#deeefe",
  lightishGreen: "#fed4d4",
  buttonShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.2)",
  showModalComponentShadow: "0 1.25em 2.625em 0 rgba(0, 0, 0, 0.07)",
};

export const videoFormats = {
  mp4: "video/mp4",
};

export const footerDetails = {
  heading: "Partner with us to build a better future",
};
export const socialMediaCred = [
  {
    socialMediaLink: "/",
    name: "Facebook",
    iconLink: facebookLogo,
  },
  {
    socialMediaLink: "/",
    name: "Twitter",
    iconLink: twitterLogo,
  },
  {
    socialMediaLink: "/",
    name: "Instagram",
    iconLink: instagramLogo,
  },
  {
    socialMediaLink: "/",
    name: "Youtube",
    iconLink: youtubeLogo,
  },
];

export enum partnerCentricPages {
  fitnessTrainer = "fitnessTrainer",
  yogaTrainer = "yogaTrainer",
  therapist = "therapist",
  nutritionist = "nutritionist",
  doctor = "doctor",
  psychiatrist = "psychiatrist",
  physiotherapist = "physiotherapist",
}

export const getPageTitle = (routeURL: string) => {
  return _.find(listOfPartners, (data) => {
    return data.type === routeURL;
  })?.name;
};

export const getPartnerSpecificImage = (routeURL: string) => {
  return _.find(listOfPartners, (data) => {
    return data.type === routeURL;
  })?.landingPageLogo;
};

export const getPartnerSpecificBckClr = (routeURL: string) => {
  return _.find(listOfPartners, (data) => {
    return data.type === routeURL;
  })?.bckColor;
};

export const getPartnerProfession = (routeURL: string) => {
  return _.find(listOfPartners, (data) => {
    return data.type === routeURL;
  })?.profession;
};

export const getPartnerPageDescription = (routeURL: string) => {
  return _.find(listOfPartners, (data) => {
    return data.type === routeURL;
  })?.pageDescription;
};

export const getProfileDescription = (profession: Profession) => {
  return _.find(listOfPartners, (data) => {
    return data.profession === profession;
  })?.profileDescriptionEg;
};
export const getonBoardingText = (profession: Profession) => {
  return _.find(listOfPartners, (data) => {
    return data.profession === profession;
  })?.onBoardingText;
};

export const getFinalOnboardText = (profession: Profession) => {
  return _.find(listOfPartners, (data) => {
    return data.profession === profession;
  })?.finalOnboardText;
};
export const getSelfieVideoDescription = (profession: Profession) => {
  return _.find(listOfPartners, (data) => {
    return data.profession === profession;
  })?.selfieVideoDescription;
};

export const listOfPartners = [
  {
    type: partnerCentricPages.fitnessTrainer,
    name: "Fitness Trainer",
    imgLink: fitnessTrainerLogo,
    mobileImgLink: fitnessTrainerMobileLogo,
    profession: Profession.FITNESS_TRAINER,
    landingPageLogo: fitnessLandingIconAsSVG,
    link: routeURL.partnerPage(partnerCentricPages.fitnessTrainer),
    bckColor: `${color.gold}`,
    pageDescription:
      "Passionate about helping people achieve their fitness goals? Keen about creating fun yet challenging strength & endurance workouts? Then this one's for you!",
    selfieVideoDescription: [
      {
        heading:
          "Upload 2 min video demonstrating how you would instruct a customer to perform these movements. Upload one video per movement",
        bullets: ["Squats", "Push ups", "Lunges"],
        extraInfo:
          "Perform the movements to show us the right form/technique and also coach the points of performance (Technique) for the customers to keep in mind while performing.",
      },
    ],
    profileDescriptionEg:
      "I'm an ACE-certified Personal Trainer with 8+ years of experience. I've done extensive research & study on PCOS & Sports Injuries and because of this, I've been able to help those struggling with these issues become their fittest selves. I believe in the mantra of holistic health & I follow it while creating my fitness plans.",
    onBoardingText:
      "Please download the Cult Trainer app from the below Appstore / Playstore link.You will be receiving login information for logging into this app shortly via email / Whatsapp.",
  },
  {
    type: partnerCentricPages.yogaTrainer,
    name: "Yoga Trainer",
    imgLink: yogaTrainerLogo,
    profession: Profession.YOGA_TRAINER,
    landingPageLogo: yogaTrainerLandingLogo,
    mobileImgLink: yogaTrainerMobileLogo,
    link: routeURL.partnerPage(partnerCentricPages.yogaTrainer),
    bckColor: `${color.lighShadeBlue}`,
    pageDescription:
      "Want to make the world a fitter place through guided Yoga practice? Ready to help someone be stress-free, relaxed and centered? This is where you can start!",
    selfieVideoDescription: [
      {
        heading:
          "Upload photo of you doing of any 2 of the below asanas (1 photo per asana)",
        bullets: [
          "Paschimottanasana",
          "Headstand",
          "Kakkasana",
          "Chaturanga Dandasana",
          "Shoulder stand",
          "Parivrtta Parsvakonasana",
          "Trikonasana",
        ],
        extraInfo: "",
      },
      {
        heading: "Upload a video basis below instruction:",
        bullets: [
          "Clearly demonstrate the process of getting into and out of the chosen asana",
          "Showcase a scaled-down version of the asana also, along with a 15-second hold",
          "All instructions should be clearly audible",
          "Place your mat horizontally in front the camera and not facing it",
          "The video must be saved in MP4 format and in your name",
          "The size of the video must not exceed 75 MB",
        ],
        extraInfo:
          "Demonstration of instructing a client one asana from the above list + One round of Surya Namaskara demonstrations with instructions in English.",
      },
    ],
    profileDescriptionEg:
      "I'm an ACE-certified Personal Trainer with 8+ years of experience. I've done extensive research & study on PCOS & Sports Injuries and because of this, I've been able to help those struggling with these issues become their fittest selves. I believe in the mantra of holistic health & I follow it while creating my fitness plans.",
    onBoardingText:
      "Please download the Cult Trainer app from the below Appstore / Playstore link.You will be receiving login information for logging into this app shortly via email / Whatsapp.",
    finalOnboardText:
      "You can start working now, download the “respective” app and get started",
  },
  {
    type: partnerCentricPages.therapist,
    name: "Therapist",
    imgLink: therapistLogo,
    profession: Profession.THERAPST,
    landingPageLogo: therapistLandingLogo,
    mobileImgLink: therapistMobileLogo,
    link: routeURL.partnerPage(partnerCentricPages.therapist),
    bckColor: `${color.brownishLightGray}`,
    pageDescription:
      "Want to make a difference in someone's life? Join us in our mission to increase mental health awareness and make it more accessible.",
    profileDescriptionEg:
      "A licensed therapist with a Masters in Clinical Psychology, I've spent the last 9 years helping individuals, couples, families and adolescents cope with their anxiety, stress, depression and addiction issues. I also have experience and knowledge in working with those diagnosed with bipolar disorder and am a certified CBT expert.",
    onBoardingText:
      "We will reach out to you to get your account set-up in our EMR tool and also guide you through next steps.Until then, you can go through the below videos to understand how our EMR tool works. You can always come back to this site to view these “how to” videos at any time.",
  },
  {
    type: partnerCentricPages.nutritionist,
    name: "Nutritionist",
    imgLink: nutritionistLogo,
    profession: Profession.NUTRITIONIST,
    landingPageLogo: nutritionistLandingLogo,
    mobileImgLink: nutritionistMobileLogo,
    link: routeURL.partnerPage(partnerCentricPages.nutritionist),
    bckColor: `${color.orangishYellow}`,
    pageDescription:
      "Love helping people get fitter & healthier by personalizing what they eat? Want to create awareness and bust myths about nutrition? Start here!",
    profileDescriptionEg:
      "Having completed my Masters in Food Science & Nutrition from the University of Mysore in 2001, I've spent 19 years helping people achieve their health goals by improving their eating & lifestyle habits. I'm passionate about food, health and well-being and believe in the power of small but sustainable changes that help us improve our health, every single day.",
    onBoardingText:
      "We will reach out to you to get your account set-up in our EMR tool and also guide you through next steps.Until then, you can go through the below videos to understand how our EMR tool works. You can always come back to this site to view these “how to” videos at any time.",
    finalOnboardText:
      "You can start working now, download the “respective” app and get started",
  },
  {
    type: partnerCentricPages.doctor,
    name: "Doctor",
    imgLink: doctorLogo,
    profession: Profession.DOCTOR,
    landingPageLogo: doctorLandingLogo,
    mobileImgLink: doctorMobileLogo,
    link: routeURL.partnerPage(partnerCentricPages.doctor),
    bckColor: `${color.lightFooter}`,
    pageDescription:
      "There's no issue too small. Join us in our efforts to make medical healthcare easy and hassle free for all.",
    profileDescriptionEg:
      "I completed my MBBS in 2008 and MD in 2010 in General Medicine from the AIIMS, New Delhi. I've been practising medicine for the last 10 years and my expertise lies in treating infectious diseases and in critical care medicine. I'm also an active member of the medical community and have hosted several talks on medical topics of importance, both nationally and internationally.",
    onBoardingText:
      "We will reach out to you to get your account set-up in our EMR tool and also guide you through next steps.Until then, you can go through the below videos to understand how our EMR tool works. You can always come back to this site to view these “how to” videos at any time.",
  },
  {
    type: partnerCentricPages.psychiatrist,
    name: "Psychiatrist",
    imgLink: psychiatristLogo,
    profession: Profession.PSYCHIATRIST,
    landingPageLogo: psychiatristLandingLogo,
    mobileImgLink: psychiatristMobileLogo,
    bckColor: `${color.seaShadeBlue}`,
    link: routeURL.partnerPage(partnerCentricPages.psychiatrist),
    pageDescription:
      "There's no issue too small. Join us in our efforts to make medical healthcare easy and hassle free for all.",
    profileDescriptionEg:
      "I completed my MBBS in 2008 and MD in 2010 in General Medicine from the AIIMS, New Delhi. I've been practising medicine for the last 10 years and my expertise lies in treating infectious diseases and in critical care medicine. I'm also an active member of the medical community and have hosted several talks on medical topics of importance, both nationally and internationally.",
    onBoardingText:
      "We will reach out to you to get your account set-up in our EMR tool and also guide you through next steps.Until then, you can go through the below videos to understand how our EMR tool works. You can always come back to this site to view these “how to” videos at any time.",
    finalOnboardText:
      "You can start working now, download the “respective” app and get started",
  },
  {
    type: partnerCentricPages.physiotherapist,
    name: "Physiotherapist",
    imgLink: physiotherapyLogo,
    profession: Profession.PHYSIOTHERAPIST,
    mobileImgLink: physiotherapyMobileLogo,
    link: routeURL.partnerPage(partnerCentricPages.physiotherapist),
    landingPageLogo: physiotherapyLandingLogo,
    bckColor: `${color.lightishGreen}`,
    pageDescription:
      "Want to make a difference in someone's life? Join us in our mission to increase mental health awareness and make it more accessible.",
    profileDescriptionEg:
      "A licensed therapist with a Masters in Clinical Psychology, I've spent the last 9 years helping individuals, couples, families and adolescents cope with their anxiety, stress, depression and addiction issues. I also have experience and knowledge in working with those diagnosed with bipolar disorder and am a certified CBT expert.",
    onBoardingText:
      "We will reach out to you to get your account set-up in our EMR tool and also guide you through next steps.Until then, you can go through the below videos to understand how our EMR tool works. You can always come back to this site to view these “how to” videos at any time.",
    finalOnboardText:
      "You can start working now, download the “respective” app and get started",
  },
];

export const navbarDetails = [
  {
    label: "Home",
    link: routeURL.landingPage,
  },
  {
    label: "Fee Structure",
    link: routeURL.feeStructurePage,
  },
  {
    label: "FAQ's",
    link: routeURL.faqPage,
  },
];
export const LandingPagedata = {
  heading: "Widen your reach to millions with us",
  subHeading: "Join our team of professionals and help the world around to",
  subHeadingHashTag: "#BeBetterEveryDay",
};
export const navBarImageLink = partnerFitLogo;
export const navBarImageLinkWhite = partnerFitWhiteLogo;

export const joinUsNowText = "Join Us Now";
export const signinText = "sign In";
export const login = "Login";
export const privayPolicy = "PRIVACY POLICY";
export const startQuiz = "Start Quiz";
export const back = "Back";
export const saveandexit = "Save and Exit";
export const discardandexit = "Discard and Exit";
export const saveText = "Save";
export const next = "Next";
export const TC = "View T&C";
export const SEEALL = "SEE ALL";
export const FAQHeader = "Frequently Asked Questions";
export const contactUs = "CONTACT US";
export const tcLabel = "TERMS AND CONDITIONS";
export const showUnsavedWarning =
  "Unsaved changes. Please remember to save the data before logging out!";
export const showNavigationStr =
  "Navigating to the next screen is not allowed. Please finish filling out the current one!";
export const footerContactDetails = [
  { name: contactUs, link: "/", mailTo: partnerEmailAddress },
  { name: tcLabel, link: `#${routeURL.termsConditionsPage}` },
  { name: privayPolicy, link: "https://static.cure.fit/privacy.html" },
];
export enum ButtonClickType {
  NEXT = "NEXT",
  SAVE_AND_EXIT = "SAVE_AND_EXIT",
}

export const faqSection = [
  {
    heading: "Live Classes",
    description: "7 Questions",
    data: [
      {
        headerText: "What are live Classes?",
        key: 1,
        itemBody: "Session Details",
      },
      {
        headerText: "What are live Classes?",
        key: 2,
        itemBody: "Session Details",
      },

      {
        headerText: "What are live Classes?",
        key: 3,
        itemBody: "Session Details",
      },
      {
        headerText: "What are live Classes?",
        key: 4,
        itemBody: "Session Details",
      },
    ],
  },
  {
    heading: "Live Classes",
    description: "7 Questions",
    data: [
      {
        headerText: "What are live Classes?",
        key: 1,
        itemBody: "Session Details",
      },
      {
        headerText: "What are live Classes?",
        key: 2,
        itemBody: "Session Details",
      },

      {
        headerText: "What are live Classes?",
        key: 3,
        itemBody: "Session Details",
      },
      {
        headerText: "What are live Classes?",
        key: 4,
        itemBody: "Session Details",
      },
    ],
  },
  {
    heading: "Live Classes",
    description: "7 Questions",
    data: [
      {
        headerText: "What are live Classes?",
        key: 1,
        itemBody: "Session Details",
      },
      {
        headerText: "What are live Classes?",
        key: 2,
        itemBody: "Session Details",
      },

      {
        headerText: "What are live Classes?",
        key: 3,
        itemBody: "Session Details",
      },
      {
        headerText: "What are live Classes?",
        key: 4,
        itemBody: "Session Details",
      },
    ],
  },
];

export const imageRenderProp = (uploadType: UploadTypes) => {
  switch (uploadType) {
    case UploadTypes.PROFILE_PICTURE:
      return (
        <div>
          <img src={uploadAvatarIcon} alt="Upload" width="110%" />
        </div>
      );

    case UploadTypes.MEDICAL_REGISTRATION_CERTIFICATE:
      return (
        <div className="d-flex justify-content-center flex-column">
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center d-md-none d-xs-block ">
              <img
                src={uploadicon}
                alt="Upload"
                className="upload-mobile-icon-width"
              />
            </div>

            <div className="upload-document-style d-sm-none d-xs-block d-xs-flex justify-content-center align-items-center ml-2 my-2 red-color-text">
              Upload Document
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center flex-column">
            <div className="upload-document-style  ml-2 my-2 d-md-block d-none">
              <div className="d-flex">
                <div>Drag items here or </div>
                <div className="browse-style px-1"> Browse </div>
                <div> and add from system</div>
              </div>
            </div>
            <div>{defaultUploadHelperText}</div>
          </div>
        </div>
      );

    case UploadTypes.SCANNED_SIGNATURE:
      return (
        <div className="d-flex justify-content-center flex-column">
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center d-md-none d-xs-block ">
              <img
                src={uploadicon}
                alt="Upload"
                className="upload-mobile-icon-width"
              />
            </div>

            <div className="upload-document-style d-sm-none d-xs-block d-xs-flex justify-content-center align-items-center ml-2 my-2 red-color-text">
              Upload Document
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center flex-column">
            <div className="upload-document-style  ml-2 my-2 d-md-block d-none">
              <div className="d-flex">
                <div>Drag items here or </div>
                <div className="browse-style px-1"> Browse </div>
                <div> and add from system</div>
              </div>
            </div>
            <div>{defaultUploadHelperText}</div>
          </div>
        </div>
      );

    case UploadTypes.GRADUATION_CERTIFICATE:
      return (
        <div className="d-flex justify-content-center flex-column">
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center d-md-none d-xs-block ">
              <img
                src={uploadicon}
                alt="Upload"
                className="upload-mobile-icon-width"
              />
            </div>

            <div className="upload-document-style d-sm-none d-xs-block d-xs-flex justify-content-center align-items-center ml-2 my-2 red-color-text">
              Upload Document
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center flex-column">
            <div className="upload-document-style  ml-2 my-2 d-md-block d-none">
              <div className="d-flex">
                <div>Drag items here or </div>
                <div className="browse-style px-1"> Browse </div>
                <div> and add from system</div>
              </div>
            </div>
            <div>{defaultUploadHelperText}</div>
          </div>
        </div>
      );

    case UploadTypes.POST_GRADUATION_CERTIFICATE:
      return (
        <div className="d-flex justify-content-center flex-column">
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center d-md-none d-xs-block ">
              <img
                src={uploadicon}
                alt="Upload"
                className="upload-mobile-icon-width"
              />
            </div>

            <div className="upload-document-style d-sm-none d-xs-block d-xs-flex justify-content-center align-items-center ml-2 my-2 red-color-text">
              Upload Document
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center flex-column">
            <div className="upload-document-style  ml-2 my-2 d-md-block d-none">
              <div className="d-flex">
                <div>Drag items here or </div>
                <div className="browse-style px-1"> Browse </div>
                <div> and add from system</div>
              </div>
            </div>
            <div>{defaultUploadHelperText}</div>
          </div>
        </div>
      );

    case UploadTypes.RESUME:
      return (
        <div className="d-flex justify-content-center flex-column">
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center d-md-none d-xs-block ">
              <img
                src={uploadicon}
                alt="Upload"
                className="upload-mobile-icon-width"
              />
            </div>

            <div className="upload-document-style d-sm-none d-xs-block d-xs-flex justify-content-center align-items-center ml-2 my-2 red-color-text">
              Upload Document
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center flex-column">
            <div className="upload-document-style  ml-2 my-2 d-md-block d-none">
              <div className="d-flex">
                <div>Drag items here or </div>
                <div className="browse-style px-1"> Browse </div>
                <div> and add from system</div>
              </div>
            </div>
            <div>{defaultUploadHelperText}</div>
          </div>
        </div>
      );

    case UploadTypes.SELFIE_VIDEO:
      return (
        <div className="d-flex justify-content-center flex-column">
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center d-md-none d-xs-block ">
              <img
                src={uploadicon}
                alt="Upload"
                className="upload-mobile-icon-width"
              />
            </div>

            <div className="upload-document-style d-sm-none d-xs-block d-xs-flex justify-content-center align-items-center ml-2 my-2 red-color-text">
              Upload Document
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center flex-column">
            <div className="upload-document-style  ml-2 my-2 d-md-block d-none">
              <div className="d-flex">
                <div>Drag items here or </div>
                <div className="browse-style px-1"> Browse </div>
                <div> and add from system</div>
              </div>
            </div>
            <div>MP4, Size less than 75Mb</div>
          </div>
        </div>
      );

    case UploadTypes.AADHAR_CARD:
      return (
        <div className="d-flex justify-content-center flex-column">
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center d-md-none d-xs-block ">
              <img
                src={uploadicon}
                alt="Upload"
                className="upload-mobile-icon-width"
              />
            </div>

            <div className="upload-document-style d-sm-none d-xs-block d-xs-flex justify-content-center align-items-center ml-2 my-2 red-color-text">
              Upload Document
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center flex-column">
            <div className="upload-document-style  ml-2 my-2 d-md-block d-none">
              <div className="d-flex">
                <div>Drag items here or </div>
                <div className="browse-style px-1"> Browse </div>
                <div> and add from system</div>
              </div>
            </div>
            <div>{defaultUploadHelperText}</div>
          </div>
        </div>
      );

    case UploadTypes.OTHER_CERTIFICATIONS:
      return (
        <div className="d-flex justify-content-center flex-column">
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center d-md-none d-xs-block ">
              <img
                src={uploadicon}
                alt="Upload"
                className="upload-mobile-icon-width"
              />
            </div>

            <div className="upload-document-style d-sm-none d-xs-block d-xs-flex justify-content-center align-items-center ml-2 my-2 red-color-text">
              Upload Document
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center flex-column">
            <div className="upload-document-style  ml-2 my-2 d-md-block d-none">
              <div className="d-flex">
                <div>Drag items here or </div>
                <div className="browse-style px-1"> Browse </div>
                <div> and add from system</div>
              </div>
            </div>
            <div>{defaultUploadHelperText}</div>
          </div>
        </div>
      );

    default:
      break;
  }
};
export const inlineSignInModalStyle = {
  mobileViewStyle: {
    maxWidth: "100%",
  },
  mobileViewStyleSignupModal: {
    maxWidth: "100%",
    margin: 0,
    height: "100%",
  },
  tabViewStyle: {
    width: "100%",
  },
  midTabWindowStyle: {
    maxWidth: "950px",
    width: "64vw",
  },
  midSizedMonitorStyle: {
    maxWidth: "950px",
    width: "64vw",
  },
};

export const inlineModalWidthStyle = {
  mobileViewStyle: "100%",
  tabViewStyle: "100%",
  midTabWindowStyle: "64vw",
  midSizedMonitorStyle: "72vw",
  deafultSignInModalWidth: "424px",
  defaultSignUpModalWidth: "850px",
  noPadding: 0,
};

export const getStepStringArrayFromAPI = (apiObject: any) => {
  return (
    apiObject &&
    apiObject.map((data: any) => {
      return data.step;
    })
  );
};

export const getRequestedPageNumber = (
  apiData: any,
  requestedPageNumber: number
) => {
  return apiData
    .map((data: any) => data.step)
    .indexOf(
      apiData
        .filter((data: any) => data.type !== StepType.DASHBOARD)
        .map((data: any) => data.step)[requestedPageNumber]
    );
};
